import { Component, OnInit, ViewChild } from '@angular/core';
import { EventosMonitoramentosDialogComponent } from 'src/app/shared/eventos-monitoramentos-dialog/eventos-monitoramentos-dialog.component';
import { LeituraEstacaoDialogComponent } from 'src/app/shared/leitura-estacao-dialog/leitura-estacao-dialog.component';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { EstacaoService } from 'src/services/estacao.service';
import { ResumoEventoDiaService } from 'src/services/resumo-evento.service';
import { TipoEventoService } from 'src/services/tipo-evento.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { MessageService, SortEvent } from 'primeng/api';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';
import { IntegracaoService } from 'src/services/integracao.service';
import { ColetaService } from 'src/services/coleta.service';
import { normalizarDialogEstacao } from 'src/app/shared/evento-total';

const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
/** COLETA e INTEGRAÇÃO: irregular = máximo do dia - quantidade regular. */
const EVENTOS_IRREGULAR_POR_MAXIMO = [7, 8];

function isEventoIrregularPorMaximo(row: any): boolean {
  const tipoId = Number(row?.tipo_evento_id);
  if (EVENTOS_IRREGULAR_POR_MAXIMO.includes(tipoId)) {
    return true;
  }

  const descricao = (row?.tipo_evento_descricao || '').toUpperCase();
  return descricao === 'COLETA' || descricao === 'INTEGRAÇÃO' || descricao === 'INTEGRACAO';
}

export type SeveridadeEvento = 'ALTA' | 'MÉDIA';

/** Mesma regra do dialog map-dialog: verde (#6c8f3f) = MÉDIA, laranja (#b0662f) = ALTA. */
function resolverSeveridadeEvento(situacaEvento: number | null | undefined): SeveridadeEvento {
  return (situacaEvento ?? 0) === 0 ? 'MÉDIA' : 'ALTA';
}

export interface LinhaProblema {
  data_resumo: string;
  data_formatada: string;
  dia_semana: string;
  estacao_id: number;
  estacao_descricao: string;
  tipo_evento_id: number;
  tipo_evento_descricao: string;
  normal: number;
  irregular: number;
  resumo_id: number;
  situaca_evento: number;
  severidade: SeveridadeEvento;
  rowRef: any;
}

@Component({
    selector: 'app-resumo-eventos',
    templateUrl: './resumo-eventos.component.html',
    styleUrls: ['./resumo-eventos.component.scss'],
    standalone: false
})
export class ResumoEventosComponent implements OnInit {
  @ViewChild(LeituraEstacaoDialogComponent) leituraEstacaoDialog?: LeituraEstacaoDialogComponent;
  @ViewChild(EventosMonitoramentosDialogComponent) eventosMonitoramentosDialog?: EventosMonitoramentosDialogComponent;

  load = false;
  consultaRealizada = false;
  rangeDate: any[] = [];
  estacao_ids: any[] = [];
  tipo_evento_ids: any[] = [];
  data: any[] = [];
  linhasProblema: LinhaProblema[] = [];
  linhasExibidas: LinhaProblema[] = [];
  buscaGrid = '';
  periodoFormatado = '';
  sortField = 'data_resumo';
  sortOrder = -1;
  private readonly camposComZebrado = ['data_resumo', 'estacao_descricao', 'tipo_evento_descricao'];
  private zebraPorLinha = new Map<string, number>();
  dropDownEstacao: any[] = [];
  dropDownTipoEvento: any[] = [];
  dropDownSeveridade = [
    { label: 'Ambas', value: 'ambas' },
    { label: 'Alta', value: 'ALTA' },
    { label: 'Média', value: 'MÉDIA' },
  ];
  severidade_filtro: 'ambas' | SeveridadeEvento = 'ambas';
  exibirFiltroAvancado = false;
  dropDownGrupos: any[] = [];
  dropDownClientes: any[] = [];
  dropDownSensores: any[] = [];
  dropDownIntegradores: any[] = [];
  dropDownColetores: any[] = [];
  grupo: any[] = [];
  cliente: any[] = [];
  sensor: any[] = [];
  plu_filtro: string | null = null;
  flu_filtro: string | null = null;
  integrador_filtro: any[] = [];
  coletor_filtro: any[] = [];
  modalEstacao = false;
  loadingDialogEstacao = false;
  estacaoDialog: any = null;
  dadosDialogEstacao: any[] = [];
  tituloModalEstacao = '';
  dataRotaModal = '';

  constructor(
    protected _estacaoService: EstacaoService,
    protected _resumoEventoService: ResumoEventoDiaService,
    protected _tipoEventoService: TipoEventoService,
    protected permissaoService: PermissoesService,
    private router: Router,
    private messageService: MessageService,
    private _estacaoGrupoService: EstacaoGrupoService,
    private _pessoaService: PessoaService,
    private _sensorService: SensorService,
    private _integracaoService: IntegracaoService,
    private _coletorService: ColetaService
  ) {}

  ngOnInit(): void {
    if (!this.permissaoService.can('monitoramento_visualizar')) {
      this.router.navigate(['/notfound']);
      return;
    }
    this.listEstacoes();
    this.listTiposEvento();
    this.listGrupos();
    this.listClientes();
    this.listSensores();
    this.listIntegradores();
    this.listColetores();
  }

  get linhasResumo(): LinhaProblema[] {
    if (this.severidade_filtro === 'ambas') {
      return this.linhasProblema;
    }
    return this.linhasProblema.filter(l => l.severidade === this.severidade_filtro);
  }

  get totalProblemas(): number {
    return this.linhasResumo.length;
  }

  get totalEstacoes(): number {
    return new Set(this.linhasResumo.map(l => l.estacao_id)).size;
  }

  get totalTiposEvento(): number {
    return new Set(this.linhasResumo.map(l => l.tipo_evento_id)).size;
  }

  toggleFiltroAvancado(): void {
    this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
  }

  listGrupos(): void {
    this.dropDownGrupos = [];
    this._estacaoGrupoService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownGrupos.push({ label: item.nome, value: item.id });
      });
    });
  }

  listClientes(): void {
    this.dropDownClientes = [];
    this._pessoaService.index().subscribe(json => {
      const ret = (json || []).filter((x: any) => x.ativo === true);
      ret.forEach((item: any) => {
        this.dropDownClientes.push({ label: item.nome, value: item.id });
      });
    });
  }

  listSensores(): void {
    this.dropDownSensores = [];
    this._sensorService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownSensores.push({ label: item.descricao, value: item.id });
      });
    });
  }

  listIntegradores(): void {
    this.dropDownIntegradores = [];
    this._integracaoService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        this.dropDownIntegradores.push({ value: item.id, label: item.descricao });
      });
    });
  }

  listColetores(): void {
    this._coletorService.index().subscribe(json => {
      this.dropDownColetores = (json || []).map((item: any) => ({ id: item.id, descricao: item.descricao }));
    });
  }

  listEstacoes(): void {
    this.dropDownEstacao = [];
    this._estacaoService.lookup().subscribe(json => {
      (json || []).forEach(item => {
        this.dropDownEstacao.push({ label: item.descricao, value: item.id });
      });
    });
  }

  listTiposEvento(): void {
    this.dropDownTipoEvento = [];
    this._tipoEventoService.listar().subscribe(json => {
      (json || []).forEach(item => {
        this.dropDownTipoEvento.push({ label: item.descricao, value: item.id });
      });
    });
  }

  filtrar(): void {
    if (!this.rangeDate || this.rangeDate.length < 2) {
      return;
    }
    this.load = true;
    this.consultaRealizada = false;
    this.data = [];
    this.linhasProblema = [];
    this.linhasExibidas = [];
    this.buscaGrid = '';

    const inicioData = moment(this.rangeDate[0]).format('YYYY-MM-DD');
    const fimData = moment(this.rangeDate[1]).format('YYYY-MM-DD');
    this.periodoFormatado = `${moment(this.rangeDate[0]).format('DD/MM/YYYY')} — ${moment(this.rangeDate[1]).format('DD/MM/YYYY')}`;

    const estacoes: any[] = [];
    if (this.estacao_ids && this.estacao_ids.length > 0) {
      this.estacao_ids.forEach(item => {
        const id = item && typeof item === 'object' ? item.value : item;
        if (id != null) estacoes.push(id);
      });
    }
    const grupoList: any[] = (this.grupo || []).map((g: any) => g && typeof g === 'object' ? g.value : g).filter((id: any) => id != null);
    const clienteList: any[] = (this.cliente || []).map((c: any) => c && typeof c === 'object' ? c.value : c).filter((id: any) => id != null);
    const sensorList: any[] = (this.sensor || []).map((s: any) => s && typeof s === 'object' ? s.value : s).filter((id: any) => id != null);
    let integradorList: any[] = [];
    if (this.integrador_filtro && this.integrador_filtro.length > 0) {
      integradorList = this.integrador_filtro.map((i: any) => i && typeof i === 'object' ? (i.value ?? i.id) : i).filter((id: any) => id != null);
    }
    let coletorList: any[] = [];
    if (this.coletor_filtro && this.coletor_filtro.length > 0) {
      coletorList = this.coletor_filtro.map((c: any) => c && typeof c === 'object' ? (c.id ?? c.value) : c).filter((id: any) => id != null);
    }
    const tipoEventoList: number[] = (this.tipo_evento_ids || [])
      .map((t: any) => t && typeof t === 'object' ? (t.value ?? t.id) : t)
      .filter((id: any) => id != null && id !== '' && !Number.isNaN(Number(id)))
      .map((id: any) => Number(id));

    this._resumoEventoService.filterMonitoramentoGridLight(
      inicioData,
      fimData,
      estacoes,
      grupoList,
      clienteList,
      sensorList,
      this.plu_filtro ?? null,
      this.flu_filtro ?? null,
      integradorList,
      coletorList,
      tipoEventoList,
      false
    ).pipe(
      finalize(() => {
        this.load = false;
      })
    ).subscribe({
      next: (json) => {
        const lista = this.normalizarRespostaGrid(json);
        this.data = lista.sort((a, b) => {
          const cmpEst = (a.estacao_descricao || '').localeCompare(b.estacao_descricao || '');
          return cmpEst !== 0 ? cmpEst : (a.tipo_evento_descricao || '').localeCompare(b.tipo_evento_descricao || '');
        });
        this.rebuildLinhasProblema();
        this.aplicarBusca();
        this.consultaRealizada = true;
      },
      error: () => {
        this.data = [];
        this.linhasProblema = [];
        this.linhasExibidas = [];
        this.consultaRealizada = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível carregar o resumo de eventos.'
        });
      }
    });
  }

  /** A API pode retornar [] ou, em respostas vazias legadas, o número 200 em vez de array. */
  private normalizarRespostaGrid(json: any): any[] {
    if (Array.isArray(json)) {
      return json;
    }
    if (json && Array.isArray(json.data)) {
      return json.data;
    }
    return [];
  }

  rebuildLinhasProblema(): void {
    const linhas: LinhaProblema[] = [];

    for (const row of this.data) {
      if (!row.por_dia_ids || typeof row.por_dia_ids !== 'object') {
        continue;
      }

      for (const dataResumo of Object.keys(row.por_dia_ids)) {
        if (!this.diaTemProblema(row, dataResumo)) {
          continue;
        }

        const m = moment(dataResumo);
        const irregular = this.getIrregularParaDia(row, dataResumo);
        const normal = this.getNormalParaDia(row, dataResumo);
        const situacaEvento = row.por_dia_situacao_evento?.[dataResumo] ?? 0;

        linhas.push({
          data_resumo: dataResumo,
          data_formatada: m.format('DD/MM/YYYY'),
          dia_semana: WEEKDAYS[m.day()],
          estacao_id: row.estacao_id,
          estacao_descricao: row.estacao_descricao,
          tipo_evento_id: row.tipo_evento_id,
          tipo_evento_descricao: row.tipo_evento_descricao,
          normal,
          irregular,
          resumo_id: row.por_dia_ids[dataResumo],
          situaca_evento: situacaEvento,
          severidade: resolverSeveridadeEvento(situacaEvento),
          rowRef: row,
        });
      }
    }

    this.linhasProblema = linhas.sort((a, b) => {
      const cmpData = b.data_resumo.localeCompare(a.data_resumo);
      if (cmpData !== 0) return cmpData;
      const cmpEst = (a.estacao_descricao || '').localeCompare(b.estacao_descricao || '');
      return cmpEst !== 0 ? cmpEst : (a.tipo_evento_descricao || '').localeCompare(b.tipo_evento_descricao || '');
    });
  }

  diaTemProblema(row: any, dataResumo: string): boolean {
    if (!row?.por_dia_ids?.[dataResumo]) {
      return false;
    }

    return this.getIrregularParaDia(row, dataResumo) > 0;
  }

  aplicarBusca(): void {
    let linhas = [...this.linhasProblema];

    if (this.severidade_filtro !== 'ambas') {
      linhas = linhas.filter(l => l.severidade === this.severidade_filtro);
    }

    const termo = (this.buscaGrid || '').trim().toLowerCase();
    if (termo) {
      linhas = linhas.filter(l =>
        (l.estacao_descricao || '').toLowerCase().includes(termo) ||
        (l.tipo_evento_descricao || '').toLowerCase().includes(termo) ||
        l.data_formatada.includes(termo) ||
        l.dia_semana.toLowerCase().includes(termo) ||
        l.severidade.toLowerCase().includes(termo)
      );
    }

    this.linhasExibidas = linhas;
    this.ordenarLinhasExibidas();
  }

  onSeveridadeFiltroChange(): void {
    this.aplicarBusca();
  }

  onSortCustom(event: SortEvent): void {
    const field = event.field ?? this.sortField;
    const order = event.order ?? this.sortOrder;
    this.sortField = field;
    this.sortOrder = order;

    event.data.sort((a: LinhaProblema, b: LinhaProblema) => this.compararLinhas(a, b, field, order));
    this.aplicarZebrado(event.data as LinhaProblema[], field);
  }

  ordenarLinhasExibidas(): void {
    if (this.linhasExibidas.length === 0) {
      this.zebraPorLinha.clear();
      return;
    }

    this.onSortCustom({
      data: this.linhasExibidas,
      field: this.sortField,
      order: this.sortOrder,
      mode: 'single'
    });
  }

  private compararLinhas(a: LinhaProblema, b: LinhaProblema, field: string, order: number): number {
    let result = 0;

    switch (field) {
      case 'data_resumo':
        result = a.data_resumo.localeCompare(b.data_resumo);
        break;
      case 'estacao_descricao':
        result = (a.estacao_descricao || '').localeCompare(b.estacao_descricao || '', 'pt-BR', { sensitivity: 'base' });
        break;
      case 'tipo_evento_descricao':
        result = (a.tipo_evento_descricao || '').localeCompare(b.tipo_evento_descricao || '', 'pt-BR', { sensitivity: 'base' });
        break;
      case 'irregular':
        result = (a.irregular ?? 0) - (b.irregular ?? 0);
        break;
      case 'severidade':
        result = (a.severidade === 'ALTA' ? 1 : 0) - (b.severidade === 'ALTA' ? 1 : 0);
        break;
      default:
        result = 0;
    }

    if (result === 0) {
      const cmpData = a.data_resumo.localeCompare(b.data_resumo);
      if (cmpData !== 0) {
        result = cmpData;
      } else {
        const cmpEst = (a.estacao_descricao || '').localeCompare(b.estacao_descricao || '', 'pt-BR', { sensitivity: 'base' });
        result = cmpEst !== 0 ? cmpEst : (a.tipo_evento_descricao || '').localeCompare(b.tipo_evento_descricao || '', 'pt-BR', { sensitivity: 'base' });
      }
    }

    return order * result;
  }

  private chaveLinha(linha: LinhaProblema): string {
    return `${linha.data_resumo}|${linha.estacao_id}|${linha.tipo_evento_id}`;
  }

  private valorGrupoZebrado(linha: LinhaProblema, field: string): string {
    switch (field) {
      case 'data_resumo':
        return linha.data_resumo;
      case 'estacao_descricao':
        return String(linha.estacao_id);
      case 'tipo_evento_descricao':
        return String(linha.tipo_evento_id);
      default:
        return '';
    }
  }

  private aplicarZebrado(linhas: LinhaProblema[], sortField: string): void {
    this.zebraPorLinha.clear();

    if (!this.camposComZebrado.includes(sortField) || linhas.length === 0) {
      return;
    }

    let grupo = 0;
    let valorAnterior: string | null = null;

    for (const linha of linhas) {
      const valorGrupo = this.valorGrupoZebrado(linha, sortField);
      if (valorAnterior !== null && valorGrupo !== valorAnterior) {
        grupo++;
      }
      this.zebraPorLinha.set(this.chaveLinha(linha), grupo % 2);
      valorAnterior = valorGrupo;
    }
  }

  classeZebrado(linha: LinhaProblema): string {
    if (this.zebraPorLinha.get(this.chaveLinha(linha)) === 1) {
      return 'linha-zebra';
    }
    return '';
  }

  onBuscaChange(): void {
    this.aplicarBusca();
  }

  getNormalParaDia(row: any, dataResumo: string): number {
    return row.por_dia_normal && row.por_dia_normal[dataResumo] != null ? row.por_dia_normal[dataResumo] : 0;
  }

  getIrregularParaDia(row: any, dataResumo: string): number {
    const normal = this.getNormalParaDia(row, dataResumo);
    const irregularBackend = row.por_dia_irregular && row.por_dia_irregular[dataResumo] != null
      ? Number(row.por_dia_irregular[dataResumo])
      : 0;

    if (isEventoIrregularPorMaximo(row)) {
      const maximo = row.por_dia_maximo?.[dataResumo] ?? 0;
      if (maximo > 0) {
        return Math.max(0, maximo - normal);
      }
    }

    return irregularBackend;
  }

  getMaximoParaDia(row: any, dataResumo: string): number {
    return row.por_dia_maximo && row.por_dia_maximo[dataResumo] != null ? row.por_dia_maximo[dataResumo] : 0;
  }

  exibeFormatoMaximo(linha: LinhaProblema): boolean {
    return isEventoIrregularPorMaximo(linha);
  }

  abrirDialogEstacao(linha: LinhaProblema): void {
    const estacaoId = Number(linha?.estacao_id);
    const dataResumo = moment(linha?.data_resumo).format('YYYY-MM-DD');

    if (!estacaoId || !dataResumo || dataResumo === 'Invalid date') {
      return;
    }

    this.modalEstacao = true;
    this.loadingDialogEstacao = true;
    this.dataRotaModal = dataResumo;
    this.tituloModalEstacao = `${linha.estacao_descricao || 'Estação'} - ${moment(dataResumo).format('DD/MM/YYYY')}`;

    this._resumoEventoService.mapDialog(estacaoId, dataResumo).subscribe({
      next: (json: any) => {
        const dialogo = normalizarDialogEstacao(json);
        this.estacaoDialog = dialogo;
        this.dadosDialogEstacao = dialogo ? [dialogo] : [];
        this.tituloModalEstacao = `${json?.descricao || linha.estacao_descricao || 'Estação'} - ${moment(dataResumo).format('DD/MM/YYYY')}`;
        this.loadingDialogEstacao = false;
      },
      error: () => {
        this.estacaoDialog = null;
        this.dadosDialogEstacao = [];
        this.loadingDialogEstacao = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível carregar os detalhes da estação.'
        });
      }
    });
  }

  changeDateDialogEstacao(direcao: 'amanha' | 'ontem'): void {
    if (!this.estacaoDialog?.id || !this.dataRotaModal) {
      return;
    }

    const base = moment(this.dataRotaModal, 'YYYY-MM-DD');
    this.dataRotaModal = direcao === 'amanha'
      ? base.add(1, 'day').format('YYYY-MM-DD')
      : base.subtract(1, 'day').format('YYYY-MM-DD');

    this.abrirDialogEstacao({
      estacao_id: this.estacaoDialog.id,
      estacao_descricao: this.estacaoDialog.descricao,
      data_resumo: this.dataRotaModal
    } as LinhaProblema);
  }

  abrirLeiturasEstacao(): void {
    const estacaoId = Number(this.estacaoDialog?.id);
    const dataResumo = this.dataRotaModal;

    if (!estacaoId || !dataResumo) {
      return;
    }

    this.leituraEstacaoDialog?.abrir({
      estacaoId,
      dataResumo,
      estacaoDescricao: this.estacaoDialog?.descricao,
    });
  }

  getIconeEvento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.tipo_evento?.icone || row?.icone || '';
  }

  getIconeMonitoramento(row: any): string {
    if (Number(row?.tipo_evento_id) === 9) {
      return 'pi pi-exclamation-triangle';
    }
    return row?.icone || row?.tipo_evento?.icone || 'pi pi-eye';
  }

  monitoramentoEstaAberto(row: any): boolean {
    return Number(row?.status) === 0;
  }

  get podeAbrirMonitoramento(): boolean {
    return this.permissaoService.can('resumo_eventos_abrir_monitoramentos');
  }

  abrirNovoMonitoramentoEstacao(event?: Event): void {
    event?.stopPropagation();
    if (!this.podeAbrirMonitoramento || !this.estacaoDialog?.id) {
      return;
    }

    this.eventosMonitoramentosDialog?.abrirNovoPorEstacao({
      estacaoId: Number(this.estacaoDialog.id),
      estacaoDescricao: this.estacaoDialog.descricao || '',
      dataResumo: this.dataRotaModal,
    });
  }

  abrirMonitoramentoEstacao(row: any): void {
    const monitoramentoId = Number(row?.id);
    if (!this.podeAbrirMonitoramento || !monitoramentoId || !this.estacaoDialog?.id) {
      return;
    }

    this.eventosMonitoramentosDialog?.abrirPorMonitoramento({
      estacaoId: Number(this.estacaoDialog.id),
      estacaoDescricao: this.estacaoDialog.descricao || '',
      dataResumo: this.dataRotaModal,
      monitoramentoId,
    });
  }

  onMonitoramentoSalvo(): void {
    if (!this.estacaoDialog?.id || !this.dataRotaModal) {
      return;
    }

    this.abrirDialogEstacao({
      estacao_id: this.estacaoDialog.id,
      estacao_descricao: this.estacaoDialog.descricao,
      data_resumo: this.dataRotaModal
    } as LinhaProblema);
  }
}
